import styled from 'styled-components';

import { resolveInputLayoutStyles } from '@dreryk/react-components';

export const StyledAvailabilityTimeRange = styled.div`
   ${resolveInputLayoutStyles};
   max-width: 330px;
`;
StyledAvailabilityTimeRange.displayName = 'StyledAvailabilityTimeRange';
